import styles from './style.module.css';
import NavLink from '@components/Common/NavLink';

import {
  faUser,
  faShieldVirus,
  faBoxOpen,
  faSignOutAlt,
} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {useRouter} from 'next/router';
import {useTranslation} from 'next-i18next';
import {ComponentWithChildrenProps} from '@interfaces/component';

interface AccountSideMenuProps extends ComponentWithChildrenProps {
  page: string;
}
export default function AccountSideMenu({
  page = 'profile',
}: AccountSideMenuProps) {
  const router = useRouter();
  const locale = router.locale;
  const {t} = useTranslation('account-details');
  return (
    <div className={styles.accountSideMenuContainer}>
      <ul className={styles.accountSideMenu}>
        <NavLink
          href={'/account/profile'}
          locale={locale}
          classNames={`${page === 'profile' ? styles.activeLink : ''}`}
        >
          <FontAwesomeIcon icon={faUser} />
          <span>{t<string>('navigation.account_details')}</span>
        </NavLink>
        <NavLink
          classNames={`${page === 'orders' ? styles.activeLink : ''}`}
          href={'/account/orders'}
          locale={locale}
        >
          <FontAwesomeIcon icon={faBoxOpen} />
          <span>{t<string>('navigation.my_orders')}</span>
        </NavLink>
        <NavLink
          classNames={`${page === 'security' ? styles.activeLink : ''}`}
          href={'/account/change-password'}
          locale={locale}
        >
          <FontAwesomeIcon icon={faShieldVirus} />
          <span>{t<string>('navigation.security')}</span>
        </NavLink>
        <NavLink>
          <FontAwesomeIcon icon={faSignOutAlt} />
          <span>{t<string>('navigation.sign_out')}</span>
        </NavLink>
      </ul>
    </div>
  );
}
